<template>
  <div class="common">
    <a-tabs v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :canEstbGldBal="item.canEstbGldBal" :statusCode="item.statusCode"
            :gldStCds="item.gldStCds" :oriGldId="item.oriGldId" :estb="userObj.cstIds.join(',')"
            :pypt="userObj.cstIds.join(',')" :tabType="item.key" :totalName="item.totalName" :selectName="item.selectName"
            :columnsSource="item.columns" :formSource="item.form" :fromTypeRouter="item.fromType" formType="issue"
            :btns="item.btns" :formBtns="item.btns" :resultCode="item.resultCode"
            :goldStatusOptions="item.goldStatusOptions" :isHaveContractNo="item.isHaveContractNo"
            fromPath="bill-issue/issue"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import payableComponent from "@/pages/bill-manage/payable/list.vue";
import goldPageComponent from "@/components/gold-page/gold-page.vue";
export default {
  components: {
    payableComponent,
    goldPageComponent
  },
  data() {
    return {
      tabData: [
        {
          name: "祺信开立",
          resultCode: 1,
          canEstbGldBal: "0.01",
          isHaveContractNo: 1,
          key: "uncommitted",
          comp: payableComponent,
          totalName: "可开立祺信余额",
          selectName: "祺信面额",
          form: [
            "sellrOrgCode",
            "docTpCd",
            "invoiceNumber",
            "billTime",
            "contractNo",
            "voucherCode"
          ],
          columns: [
            "卖方名称",
            "单据类型",
            "单据编号",
            "应付金额(元)",
            "起始日期",
            "合同编号",
            "相关凭证",
            "可开立余额(元)",
            "祺信金额"
          ],
          btns: ["openGold"]
        },

        {
          name: "待复核",
          gldStCds: 7,
          fromType: "3",
          oriGldId: 0,
          key: "pendingReview",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "当前审批人",
            "有无发票",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "待担保",
          gldStCds: 9,
          fromType: "3",
          oriGldId: 0,
          key: "guaranteed",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "待确认",
          gldStCds: 5,
          fromType: "3",
          oriGldId: 0,
          key: "tobeConfirmed",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "待审批人",
            "变更状态",
            "有无发票",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "待签收",
          gldStCds: 0,
          fromType: "3",
          oriGldId: 0,
          key: "pendingReceipt",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "有无发票",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "已签收",
          gldStCds: 1,
          fromType: "3",
          oriGldId: 0,
          key: "signed",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "有无发票",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "已拒绝",
          gldStCds: "3,8,10,4",
          fromType: "3",
          oriGldId: 0,
          key: "refused",
          comp: goldPageComponent,
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "有无发票",
            "操作"
          ],
          form: ["开立日期", "祺信编号", "接收方", "到期日期", "变更状态"]
        },
        {
          name: "全部",
          oriGldId: 0,
          fromType: "3",
          key: "all",
          comp: goldPageComponent,
          goldStatusOptions: [
            { value: "0", name: "待签收" },
            { value: "1", name: "已签收" },
            { value: "2", name: "已撤销" },
            { value: "3", name: "已拒绝" },
            { value: "4", name: "确认已拒绝" },
            { value: "5", name: "待确认" },
            { value: "6", name: "已结清" },
            { value: "7", name: "待复核" },
            { value: "8", name: "复核已拒绝" },
            { value: "9", name: "待担保" },
            { value: "10", name: "担保已拒绝" },
          ],
          columns: [
            "开立日期",
            "祺信编号",
            "担保方",
            "接收方",
            "祺信面额(元)",
            "到期日期",
            "变更状态",
            "祺信状态",
            "有无发票",
            "操作"
          ],
          form: [
            "开立日期",
            "祺信编号",
            "接收方",
            "到期日期",
            "变更状态",
            "祺信状态"
          ]
        }
      ],
      tabCur: "uncommitted"
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"
    })
  },
  created() { },
  mounted() { },
  methods: {},
  activated() { }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-issue/issue.vue